import { Directive, NgZone, AfterViewInit } from '@angular/core';
@Directive({
  selector: '[axis-accessibility]',
})
export class AxisAccessibilityDirective implements AfterViewInit {
  constructor(private zone: NgZone) { }

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {

      window.document.addEventListener('click', (event: MouseEvent) => {
        if (event.detail !== 0) { // detail:0 when keyup invokes click
          document.body.classList.remove('axis-keyboard');
        }
      });

      window.document.addEventListener('keyup', () => {
        // keyup allows time for actions to happen (keydown too soon)
        document.body.classList.remove('axis-touch');
        document.body.classList.add('axis-keyboard');
      });

      window.document.addEventListener('mousemove', () => {
        document.body.classList.remove('axis-keyboard');
      });

      window.document.addEventListener('touchstart', () => {
        // replaced TouchEvent type with any, as TouchEvent will not work on mozilla.
        document.body.classList.remove('axis-keyboard');
        document.body.classList.add('axis-touch');
      });
    });
  }
}
